import http from "../services/http";

// Get all patients (with optional filters)
export const apiGetPatients = async (params) => {
  try {
    const response = await http.get("/api/doctor/patients", {
      params,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get patient details by ID
export const apiGetPatientDetails = async (patientId) => {
  try {
    const response = await http.get(`/api/doctor/patients/details`, {
      params: { patient_id: patientId },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update patient
export const apiUpdatePatient = async (payload) => {
  try {
    const response = await http.post("/api/doctor/patients/update", {
      ...payload,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
